import React, { useEffect, useState } from 'react'
import formattedDate from "../../utils/formattedDate";
import {
  Card,
  CardHeader,
  Col,
  Row,
  CardBody,
  Button,
} from "shards-react";
import useGetReports from '../../hooks/useGetReports';

export default function PastReportsTable({ handleDeleteReport, selectedUser }) {

  const { isLoading, docs } = useGetReports();
  const [reports, setReports] = useState(null);

  useEffect(() => {
    const currentUserReports = docs.filter(doc => {
      return doc.uid === selectedUser.id
    })
    setReports(selectedUser && currentUserReports)
  }, [docs, selectedUser])

  return (
    <>
      {!isLoading && (
        <Row>
          <Col>
            <Card small className="mb-4 ">
              <CardHeader className="border-bottom">
                <h6 className="m-0">Past User Reports</h6>
              </CardHeader>
              <CardBody className="p-0 pb-3">
                <table className="table mb-0">
                  <thead className="bg-light">
                    <tr>
                      <th scope="col" className="border-0">
                        Date
                      </th>
                      <th scope="col" className="border-0">
                        PDF
                      </th>
                      <th scope="col" className="border-0">
                        Actions
                      </th>
                    </tr>
                  </thead>
                  {reports && reports.length > 0 ? (
                    <>
                      <tbody >
                        {reports.map(report => {
                          return(
                            <tr key={report.id}>
                            <td>{formattedDate(report.createdAt ? report.createdAt.seconds : 'loading...')}</td>
                            <td>
                              <a className={report.url ? 'linkButton' : 'linkButton disabled'} href={report.url} >
                                {report.filename ? report.filename :  'No report found'}
                              </a>
                            </td>
                            <td>
                              <Button onClick={() => {handleDeleteReport(report.url, report.id)}} theme="danger">Delete</Button>
                            </td>
                          </tr>
                          )

                        })}
                      </tbody>
                    </>
                  ) :
                    (<tbody>
                      <tr>
                        <td>No reports found</td>
                        <td></td>
                        <td></td>
                      </tr>
                    </tbody>
                    )}
                </table>
              </CardBody>
            </Card>
          </Col>
        </Row>
      )}

    </>
  )
}
